module.exports = __webpack_public_path__ + "img/souvenir2.eca011c0.svg";